import { render, staticRenderFns } from "./SetHandlingFee.vue?vue&type=template&id=5391a13c"
import script from "./SetHandlingFee.vue?vue&type=script&lang=js"
export * from "./SetHandlingFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports